import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Info } from 'common/images/FaIcons';
import Button from 'common/components/atoms/Button';
import Modal from 'common/components/organisms/Modal';

const DialogBody = styled.div`
  padding: 4px 24px 20px;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
`;

const IconBadge = styled.div`
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.primaryColor};
  background: ${props => props.theme.colors.greyXXL || '#f1f3f2'};
`;

const DialogTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.35;
  color: ${props => props.theme.colors.black};
`;

const DialogMessage = styled.p`
  margin: 0 0 8px;
  font-size: 13px;
  line-height: 1.55;
  color: ${props => props.theme.colors.greyXXD};
`;

const DialogSecondaryMessage = styled.p`
  margin: 0;
  padding: 10px 12px;
  font-size: 12.5px;
  line-height: 1.5;
  color: ${props => props.theme.colors.greyXXD};
  background: ${props => props.theme.colors.greyXXL || '#f7f8f7'};
  border-radius: 4px;
`;

const ActionsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`;

const CouplingConfirmAlert = ({ title, message, secondaryMessage, onProceed, onCancel }) => {
  const { t } = useTranslation();

  return (
    <Modal
      className="coupling-confirm-alert"
      width="420px"
      padding="0"
      headerHeight="42px"
      close={onCancel}
    >
      <DialogBody>
        <TitleRow>
          <IconBadge>
            <Info size="sm" />
          </IconBadge>
          <DialogTitle>
            {title || t('common.confirm')}
          </DialogTitle>
        </TitleRow>
        <DialogMessage>{message}</DialogMessage>
        {secondaryMessage ? (
          <DialogSecondaryMessage>{secondaryMessage}</DialogSecondaryMessage>
        ) : null}
        <ActionsRow>
          <Button
            className="alert-prompt-cancel"
            cancel
            onClick={onCancel}
          >
            {t('common.cancel')}
          </Button>
          <Button
            className="alert-prompt-confirm"
            onClick={onProceed}
          >
            {t('common.confirm')}
          </Button>
        </ActionsRow>
      </DialogBody>
    </Modal>
  );
};

CouplingConfirmAlert.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  secondaryMessage: PropTypes.string,
  onProceed: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

CouplingConfirmAlert.defaultProps = {
  title: '',
  secondaryMessage: ''
};

export default CouplingConfirmAlert;
